import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../../../../admin/src/app/services/category.service';
import { FaqService } from '../../../../../admin/src/app/services/faq.service';
import { Pagination } from '../../../../../admin/src/app/models/pagination';
import { Category } from '../../../../../admin/src/app/models/category';
import { Faq } from '../../../../../admin/src/app/models/faq';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../services/language.service';
import { SearchService } from '../../services/search.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit, OnDestroy {

  kbLink: string = environment.knowledgeBaseUrl;

  forumLink: string = environment.forumUrl;

  categories: Category[] = [];

  faqs: Faq[] = [];

  pagination: Pagination = new Pagination();

  query: string;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private categorySvc: CategoryService,
    private faqService: FaqService,
    private searchSvc: SearchService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Home');

    this.sub = this.route.paramMap.subscribe(params => {
      const language = params.get('language');
      if (!language) {
        this.router.navigate(['/', this.language.getLang()]);
      }
    });

    this.pagination.elementsPerPage = 5;

    this.getCategories();
    this.getFaqs();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCategories() {
    this.categories = [];
    this.categorySvc.getAll(Object.assign({}, this.pagination, { elementsPerPage: 1000, sort: 'index' })).subscribe(data => {
      this.categories = data.payload.elements.filter(c => !c.parentCategory);
    });
  }

  getFaqs() {
    this.faqService.getAll(null, this.pagination).subscribe(data => {
      this.faqs = Object.assign([], data.payload.elements);
    });
  }

  updateSearch() {
    this.searchSvc.isZendeskResultsVisible = false;
    this.searchSvc.isProductsVisible = false;
    this.searchSvc.isFaqsVisible = false;
    this.router.navigate([this.language.getLang() + '/search'], { queryParams: { q: this.query }, queryParamsHandling: 'merge' });
  }

}
